<!--
무자료 등록(재고방식) 컴포넌트
------------------------------------
-->
<template>
    <div class="uk-flex uk-flex-between uk-flex-stretch uk-height-1-1">
        <!-- 진행단계 -->
        <stepper
            :currentStep="currentStep"
            :box="box"
            :prods="prods"
            :box-user-nick="boxUserNick"
            :prod-count="prodCount"
            :total-amount="totalAmount"
        ></stepper>

        <!-- 메인컨텐츠 -->
        <div class="uk-width-expand uk-height-1-1 uk-overflow-auto">

            <!-- 기본정보 -->
            <make-box
                v-show="currentStep === 1"

                :region-id="regionId"
                :region-code="regionCode"

                :box="box"
                :regionMemberOptions="regionMemberOptions"
                :box-user-nick="boxUserNick"

                @cancel="cancel"
                @done="currentStep = 2"
            ></make-box>

            <!-- 상품추가 -->
            <prod-list
                v-show="currentStep === 2"

                :csrf-token="csrfToken"
                :region-id="regionId"
                :region-code="regionCode"

                :session-owner="sessionOwner"
                :box-user-nick="boxUserNick"
                :box="box"
                :prods="prods"
                :prod-count="prodCount"
                :regionMemberOptions="regionMemberOptions"

                @cancel="cancel"
                @done="currentStep = 3"
            ></prod-list>

            <!-- 라벨출력 -->
            <label-guide
                v-show="currentStep === 3"

                :csrf-token="csrfToken"
                :region-id="regionId"
                :region-code="regionCode"

                :box="box"
                :prods="prods"

                @back="currentStep = 2"
                @done="registerd"
            ></label-guide>

        </div>


    </div>
</template>

<script>
    export default {
        components: {
            'stepper': require('./stepper.vue').default,
            'make-box': require('./make-box.vue').default,
            'prod-list': require('./prod-list.vue').default,
            'label-guide': require('./label-guide.vue').default,
        },
        props: {
            // csrf-token
            csrfToken: String,

            // 지역ID
            regionId: Number,

            /**
             * 지역코드
             * (미국 커스텀때문에 추가됨)
             * 1 : 일본
             * 2 : 미국
             * 3 : 중국항공
             * 4 : 중국해상
             * 5 : 영국
             * 6 : 독일
             * 7 : 호주
             **/
            regionCode: {
                type: Number,
                default: null,
            },


        },
        data: function () {
            return {
                // (int) 현재 진행단계
                currentStep: 1,

                /**
                 * (object) 박스정보
                 * {
                 *     tracking_no,
                 *     user_id,
                 *     name_prefix,
                 * }
                 */
                box: {},

                // (array) 등록된 상품정보 배열
                prods: [],

                // (array) 지역 회원사 옵션
                regionMemberOptions: [],

                // (int) 업로드모듈에서 사용할 로그인ID
                sessionOwner: null,
            };
        },
        computed: {
            /**
             * 박스정보의 회원사 닉네임
             */
            boxUserNick() {
                let opt = _.find(this.regionMemberOptions, {val: this.box.user_id});
                if (opt) {
                    return opt.text;
                } else {
                    return null;
                }
            },

            /**
             * 상품 수(품목)
             */
            prodCount() {
                return this.prods.length;
            },

            /**
             * 총 상품 수량
             */
            totalAmount() {
                return _.sumBy(this.prods, 'amount');
            },

        },
        methods: {
            /**
             * 초기화
             * @param tracking_no
             * @param user_id
             * @param name_prefix
             */
            init(tracking_no, user_id, name_prefix) {
                if (! user_id) {
                    user_id = null;
                }
                if (! name_prefix) {
                    name_prefix = '무자료(전체)';
                }

                this.currentStep = 1;
                this.box = {
                    tracking_no,
                    user_id,
                    name_prefix,
                    storage: null,
                };

                this.prods = [];

                this.load();
            },

            /**
             * ajax 패킹정보 조회
             */
            load() {
                // promise 생성
                let p = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/regions/' + this.regionId + '/nodata-init-data',
                        data: {
                            //'_token': this.csrfToken,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                        error: (jqXHR, textStatus, errorThrown) => {
                            // promise 실패
                            reject();
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                p.then((response) => {
                    // 결과저장
                    this.regionMemberOptions = response.region_member_options;
                    this.sessionOwner = response.session_owner;

                }).catch(() => {
                    this.cancel();
                });
            },

            /**
             * 취소
             */
            cancel() {
                this.$emit('cancel');
            },

            /**
             * 등록완료 이벤트 리스너
             */
            registerd() {
                // 이벤트 발생
                this.$emit('registerd');
            },
        },


    }
</script>

<style lang="scss" scoped>

</style>